import clsx from "clsx";
import get from "lodash/get";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useRouteMatch } from "react-router-dom";

import Filter from "~/components/Filter";
import DealersHtmlFilesForm from "~/components/Forms/DealersHtmlFilesForm";
import PKDUploadFileForm from "~/components/Forms/PKDUploadFileForm";
import UploadHTMLForm from "~/components/Forms/UploadHTMLForm";
import Back from "~/components/Icons/arrow-prev2";
import IconFilter from "~/components/Icons/icon-filter";
import Pagination from "~/components/Pagination";
import Search from "~/components/Search";
import Table from "~/components/Table";
import DealersFilter from "~/pages/Dealers/DealersFilter";
import Button from "~/shared/ui/Fields/Button";
import Modal from "~/shared/ui/Fields/Modal";
import { NOTIFICATIONS } from "~/constans/notifications";
import { getCookie, setCookie } from "~/hooks/filterCookie";
import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import { onScrollBottomDealers } from "~/hooks/selectDealerValue";
import { mapDealerItem } from "~/pages/Dealers/model/mapDealerItem";
import { ARR_INCLUDE_EN, DEALER_OPTIONS } from "~/pages/Dealers/options";
import {
  DealersLocationItem,
  useGetDealersLocationItemQuery,
  useGetDealersQuery,
} from "~/schemas/generated/graphql";
import { usePermissions } from "~/shared/context/PermissionContext";

import s from "./Dealers.less";
const language = localStorage.getItem("language");
const isEn = language === "en";
const filterInitDealers = {
  id: undefined,
  DealerName: undefined,
  INN: undefined,
  status: "common.not_selected",
  code: undefined,
  address: undefined,
  birCode: undefined,
  category: undefined,
  regionalServiceManager: undefined,
  regionalSalesManager: undefined,
  OrganizationalLegalForm: undefined,
  EP: undefined,
  headName: undefined,
  headCompanyName: undefined,
  ContractEndDate: undefined,
  FO: {
    label: isEn ? "Not chosen" : "Не выбрано",
    value: null,
  },
  subject: {
    label: isEn ? "Not chosen" : "Не выбрано",
    value: null,
  },
  country: {
    label: isEn ? "Not chosen" : "Не выбрано",
    value: null,
  },
  city: {
    label: isEn ? "Not chosen" : "Не выбрано",
    value: null,
  },
};

const DealersArchive = () => {
  const { t } = useTranslation();
  const language = localStorage.getItem("language");
  const isEn = language === "en";
  const noCaching = sessionStorage.getItem("noCaching");
  const setData = useSetLocationData();
  const history = useHistory();
  const { params } = useRouteMatch();
  const idArchive = params["period"];

  const goBack = () => {
    history.replace("/dealers/period/");
  };

  const openAdd = () => {
    history.replace("/dealers/add");
  };
  const {
    count,
    page,
    searchField,
    searchText,
    openModal,
    sortField,
    sortType,
  } = useGetLocationData();
  const { hasPermission } = usePermissions();
  const openPkdFiles = () => {
    history.push(`/reg_men/`);
  };
  const canViewDealers = hasPermission("dealers.getDealers");

  const getcokier =
    !!getCookie("filterInitDealers") &&
    JSON.parse(getCookie("filterInitDealers"));

  const [filterSettings, setFilterSettings] = useState(
    getcokier
      ? JSON.stringify(getcokier) === JSON.stringify(filterInitDealers)
        ? filterInitDealers
        : getcokier
      : filterInitDealers,
  );

  useEffect(() => {
    setCookie("filterInitDealers", JSON.stringify(filterSettings), 3);
  }, [filterSettings]);

  const resetFilter = () => {
    setFilterSettings(filterInitDealers);
  };

  const filterSettingsArr = Object.keys(filterSettings)
    .filter((el) => {
      if (typeof filterSettings[el] === "object" && el !== "ContractEndDate") {
        return !!filterSettings[el]?.value;
      } else {
        return (
          !!filterSettings[el] && filterSettings[el] !== "common.not_selected"
        );
      }
    })
    .map((el) => {
      if (isEn && ARR_INCLUDE_EN.includes(el)) {
        return `${el}En`;
      } else {
        return el;
      }
    });

  const filterSettingsMass = Object.keys(filterSettings)
    .filter((el) => {
      if (typeof filterSettings[el] === "object" && el !== "ContractEndDate") {
        return !!filterSettings[el]?.value;
      } else {
        return (
          !!filterSettings[el] && filterSettings[el] !== "common.not_selected"
        );
      }
    })
    .reduce((cur, key) => {
      return Object.assign(cur, {
        [isEn && ARR_INCLUDE_EN.includes(key) ? `${key}En` : key]:
          typeof filterSettings[key] === "object" && key !== "ContractEndDate"
            ? filterSettings[key].value
            : filterSettings[key],
      });
    }, {});

  const filterIsOpen = openModal === "Filter";

  const dealersForSelect = canViewDealers ? onScrollBottomDealers() : [];
  const { data, loading, refetch } = useGetDealersQuery({
    variables: {
      count,
      page,
      search: { SearchFields: filterSettingsArr, ...filterSettingsMass },
      sortField,
      sortType,
      archivePeriodId: idArchive,
      doSearchArchive: !!idArchive,
    },
    fetchPolicy: noCaching ? "cache-and-network" : "cache-first",
  });

  const toggleFilter = () => {
    openModal
      ? setData("openModal", "", "page", "")
      : setData("openModal", "Filter");
  };

  const dealers = get(data, "DealerGetter.getDealers.items", []).map((dealer) =>
    mapDealerItem(dealer, isEn, t, "address"),
  );

  const total = get(data, "DealerGetter.getDealers.total", 0);

  const handleCloseModal = () => {
    setData("openModal", "");
  };

  const OpenhtmlUpload = () => {
    setData("openModal", "htmlUpload");
  };

  return (
    <>
      <div className={clsx(s.wrapper, s.dealersPage)}>
        <div className={s.s_dealer_title}>{t("dealers.dealer_register")}</div>
        <div className={s.search}>
          <div className={s.dealersFilterTrigger}>
            <Button
              txtBtn={filterIsOpen ? t("ui.hide") : t("ui.filter")}
              onClick={toggleFilter}
              small
              customClassName={s.add_bth}
            >
              <IconFilter />
            </Button>
            {filterIsOpen && (
              <DealersFilter
                toggleModal={toggleFilter}
                {...{
                  refetch,
                  dealersForSelect,
                  filterSettings,
                  setFilterSettings,
                  resetFilter,
                }}
              />
            )}
          </div>

          <Button
            txtBtn={"Назад"}
            onClick={goBack}
            small
            customClassName={s.add_bth}
          >
            <Back />
          </Button>
        </div>

        <Pagination total={total}>
          <Table
            options={DEALER_OPTIONS}
            items={dealers}
            loading={loading}
            refetch={refetch}
            type={"dealers"}
            customClassName={s.dealers_table}
          />
        </Pagination>

        <Modal
          isOpen={openModal === "htmlUpload"}
          title={t("dealers.htmlUpload")}
          actionClose={handleCloseModal}
        >
          <DealersHtmlFilesForm setCloseModal={handleCloseModal} />
        </Modal>
      </div>
    </>
  );
};

export default DealersArchive;
